import React from 'react';

import {useDarkWidgets, useTheme} from 'pageflow-scrolled/frontend';

import styles from './LinkListFooter.module.css';

export function Logo() {
  const theme = useTheme();
  const darkWidgets = useDarkWidgets();

  const srcDesktop =
    darkWidgets ?
    theme.assets.footerLogoDarkVariantDesktop :
    theme.assets.footerLogoDesktop;

  const srcMobile =
    darkWidgets ?
    theme.assets.footerLogoDarkVariantMobile :
    theme.assets.footerLogoMobile;

  if (!srcDesktop && !srcMobile) {
    return null;
  }

  return (
    <a href={theme.options.footerLogoUrl}
       className={styles.logo}>
      <picture>
        <source media="(max-width: 780px)" srcSet={srcMobile} />
        <source media="(min-width: 781px)" srcSet={srcDesktop} />
        <img src={srcDesktop}
             alt={theme.options.footerLogoAltText} />
      </picture>
    </a>
  );
}
